import {Component, Inject} from '@angular/core';
import {GlobalSettings} from '../_providers';
import {AddressResource, ClientResource, Settings} from '../_services';
import {Observable} from 'rxjs/Observable';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

export interface ConfirmInterface {
  title: string;
  message: any;
}

@Component({
  selector: 'app-address',
  template: `
    <div mat-dialog-title>
      <h4 class="modal-title">{{whitelabel.ask_home_address_label}}</h4>
    </div>
    <div mat-dialog-content>
      <form [formGroup]="form">
        <div class="form-group-lg">
          <mat-form-field style="width:100%">
            <input matInput formControlName="address" placeholder="Street address and number" type="text">
          </mat-form-field>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-8">
              <mat-form-field style="width:100%">
                <input matInput formControlName="country" placeholder="Country" type="text" [matAutocomplete]="countries">
                <mat-autocomplete #countries="matAutocomplete">
                  <mat-option *ngFor="let option of filteredCountries | async" [value]="option">
                    {{option}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
              <mat-form-field style="width:100%">
                <input matInput formControlName="postcode" placeholder="Postcode" type="text">
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
      <ng-container *ngIf="locations.length > 0">
        <mat-divider></mat-divider>
        <mat-form-field style="width:100%">
          <mat-label>Please select a location</mat-label>
          <mat-select [formControl]="selected">
            <mat-option *ngFor="let o of locations" [value]="o">
              - {{o.street}}, {{o.postalCode}}, {{o.adminArea5}} , {{o.adminArea4}}, {{o.adminArea3}}, {{o.adminArea1}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button color="primary" type="button" (click)="lookup()" *ngIf="!locations || locations.length === 0">Search</button>
      <button mat-raised-button color="warn" type="button" (click)="save()" *ngIf="locations.length > 0" [disabled]="selected.invalid">Select
      </button>
      <span style="flex: 1 1 auto"></span>
      <button mat-flat-button type="button" (click)="close()">Cancel</button>
    </div>
  `
})
export class AddressComponent {
  whitelabel: Settings;
  filteredCountries: Observable<string[]>;
  form: FormGroup;
  selected = new FormControl('', Validators.required);
  locations = [];

  constructor(
    public dialogRef: MatDialogRef<AddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private globalSettings: GlobalSettings,
    private address: AddressResource,
    private client: ClientResource,
    private fb: FormBuilder
  ) {
    this.whitelabel = globalSettings.whitelabel;
    globalSettings.whitelabel$.subscribe(val => {
      this.whitelabel = val;
    });

    this.form = fb.group({
      address: [sessionStorage.getItem('address'), Validators.required],
      country: [sessionStorage.getItem('country'), Validators.required],
      postcode: [sessionStorage.getItem('postcode'), Validators.required]
    });

    this.form.valueChanges.subscribe(() => {
      this.locations = [];
      this.selected.reset();
    });

    this.filteredCountries = this.form.controls['country'].valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCountry(value))
      );
  }

  lookup(): void {
    console.log(this.form.value);
    this.address.validate(this.form.value).subscribe(r => {
      if (r.locations) {
        this.locations = r.locations;
      }
    }, err => console.warn(err));
    // this.dialogRef.close(this.form.value);
  }

  save(): void {
    console.log('save', this.selected.value);
    if (sessionStorage.getItem('currentAppointmentUser')) {
      const $data = Object.assign({
        latitude: this.selected.value['latLng']['lat'],
        longitude: this.selected.value['latLng']['lng'],
        client_id: sessionStorage.getItem('currentAppointmentUser')
      }, this.form.value);
      this.client.addAddress($data).subscribe(res => {
        this.dialogRef.close(res.address_id);
      }, console.warn);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  private _filterCountry(value: string): string[] {
    const filterValue = value.toLowerCase();

    const $options = ['United States', 'Canada', 'Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and/or Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Cook Islands', 'Costa Rica', 'Croatia (Hrvatska)', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecudaor', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'France, Metropolitan', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and Mc Donald Islands', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran (Islamic Republic of)', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, Democratic People\'s Republic of', 'Korea, Republic of', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Lao People\'s Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfork Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia South Sandwich Islands', 'South Sudan', 'Spain', 'Sri Lanka', 'St. Helena', 'St. Pierre and Miquelon', 'Sudan', 'Suriname', 'Svalbarn and Jan Mayen Islands', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States minor outlying islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City State', 'Venezuela', 'Vietnam', 'Virigan Islands (British)', 'Virgin Islands (U.S.)', 'Wallis and Futuna Islands', 'Western Sahara', 'Yemen', 'Zaire', 'Zambia', 'Zimbabwe'];

    return $options.filter(option => option.toLowerCase().includes(filterValue)).sort((a, b) => a > b ? 1 : (a < b ? -1 : 0));
  }


}
